import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  description: () => faker.lorem.sentence(),
  isArchived: false,
  link: () => faker.internet.url(),
  shouldSendPushNotification: false,
  title: () => faker.lorem.word(),
  numSeen: () => faker.number.int(100),
});
